define.alias("shared/utils/escape-html", "settings/utils/escape-html");